module.exports = __webpack_public_path__ + "static/media/orange.ed570fa8.jpg";